import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { Model } from "../../../../services/api/instances/embeddingsApi/types";
import { AppButton } from "../../../../shared/components/AppButton";
import { AnalyzeIcon } from "../../../../shared/icons/AnalyzeIcon";
import { PlusIcon } from "../../../../shared/icons/PlusIcon";
import { useEmbeddings } from "../../hooks/use-embeddings";
import { useEmbeddingsSettings } from "../../hooks/use-embeddings-settings";
import { SidebarListItem } from "./SidebarListItem";
import { SidebarSelect } from "./SidebarSelect";
import styles from "./styles.module.css";

export const Sidebar = () => {
  const { t } = useTranslation();
  const {
    models,
    selectedModel,
    inputValues,
    isDisabled,
    isLoading,
  } = useEmbeddings();
  const {
    addInputValue,
    deleteInputValue,
    handleInputChange,
    handleSelectModel,
    handleModeling,
  } = useEmbeddingsSettings();

  const handleDeleteItem = (id: string) => {
    deleteInputValue(id);
  };

  return (
    <aside className={styles.sidebar}>
      <div className={styles["top-container"]}>
        <div className={styles.values}>
          <h2 className={styles.title}>{t("embeddings.model")}</h2>
          <div className={styles["select-container"]}>
            <SidebarSelect
              className={styles.select}
              onChange={handleSelectModel}
              models={models}
              selectedModel={selectedModel as Model}
            />
          </div>
          <h3 className={styles.title}>{t("embeddings.values")}</h3>
          <ul className={styles.list}>
            {inputValues.map((item) => (
              <SidebarListItem
                key={item.id}
                inputValue={item}
                onDelete={handleDeleteItem}
                onInputChange={handleInputChange}
              />
            ))}
          </ul>
          <AppButton
            className={styles["add-button"]}
            buttonType="text"
            icon={<PlusIcon/>}
            onClick={addInputValue}
          >
            {t("embeddings.add")}
          </AppButton>
        </div>
      </div>
      <div className={styles["bottom-container"]}>
        <AppButton
          className={classNames(styles["analyze-button"], {
            [styles.disabled]: isDisabled || isLoading,
          })}
          buttonType="contained"
          icon={<AnalyzeIcon/>}
          onClick={handleModeling}
          disabled={isDisabled || isLoading}
        >
          {t("embeddings.simulate")}
        </AppButton>
      </div>
    </aside>
  );
};
